// src/services/axios.js
import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Accept'] = 'application/json'

// Get CSRF token from meta tag and set it in axios
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken
}

axios.interceptors.request.use(config => {
  const url = String(config?.url || '')
  if (!url.startsWith('/api/v2/')) {
    return config
  }

  if (config.params && typeof config.params === 'object' && !Array.isArray(config.params) && Object.hasOwn(config.params, 'store_id')) {
    const params = { ...config.params }

    delete params.store_id
    config.params = params
  }

  if (config.data instanceof FormData) {
    config.data.delete('store_id')

    return config
  }

  if (config.data && typeof config.data === 'object' && !Array.isArray(config.data) && Object.hasOwn(config.data, 'store_id')) {
    const payload = { ...config.data }

    delete payload.store_id
    config.data = payload
  }

  return config
})

// Track last 401 redirect to prevent loops
let last401Redirect = 0
const REDIRECT_COOLDOWN = 5000 // 5 seconds between redirects

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname
      const now = Date.now()

      // Prevent redirect loops - only redirect if we haven't redirected in the last 5 seconds
      if (!currentPath.includes('/login') && (now - last401Redirect) > REDIRECT_COOLDOWN) {
        console.warn('[401 Interceptor] Session expired, redirecting to login')
        last401Redirect = now
        window.location.href = '/login'
      } else if ((now - last401Redirect) <= REDIRECT_COOLDOWN) {
        console.warn('[401 Interceptor] Suppressing redirect to prevent loop')
      }
    }

    return Promise.reject(error)
  },
)

export default axios
